function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Vipps = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, React) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = void 0;
  React = _interopRequireWildcard(React);

  function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

  function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

  function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

  var SvgVipps = function SvgVipps(props) {
    return /*#__PURE__*/React.createElement("div", {
      className: props.className,
      style: props.style
    }, /*#__PURE__*/React.createElement("svg", _extends({
      viewBox: "0 0 60 40",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props), /*#__PURE__*/React.createElement("title", null, "vipps"), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
      id: "vipps",
      stroke: "none",
      strokeWidth: 1,
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/React.createElement("rect", {
      id: "Rectangle-path",
      fill: "#FF5B24",
      fillRule: "nonzero",
      x: 0,
      y: 0,
      width: 60,
      height: 40
    }), /*#__PURE__*/React.createElement("path", {
      d: "M30.6112879,25.668338 C33.8743603,25.6504599 36.8960208,23.9459811 38.5990722,21.1625341 C39.7253754,19.7288613 41.1592568,19.4216308 42.1833237,20.2408774 C42.7045906,20.7331536 43,21.4184543 43,22.1354307 C43,22.852407 42.7045906,23.5377077 42.1833237,24.029984 C39.5795065,27.8792205 35.2580387,30.2120335 30.6112879,30.2767954 C25.1892267,30.1244277 20.2479205,27.1285088 17.6055795,22.3914213 C17.1668548,21.8966436 16.9511973,21.2430578 17.0093144,20.5843418 C17.0674316,19.9256258 17.3941959,19.3198968 17.9127752,18.90958 C18.5045869,18.557293 19.2164236,18.4675268 19.8771669,18.6618604 C20.5379102,18.8561939 21.087801,19.3170512 21.3946513,19.9336469 C23.2747345,23.3044354 26.7566851,25.4709427 30.6112879,25.668338 Z M37.6773807,13.0722354 C37.6773807,14.3148418 36.9288508,15.4350925 35.7808309,15.9106141 C34.6328109,16.3861358 33.311385,16.123282 32.4327345,15.2446216 C31.5540841,14.3659612 31.2912453,13.0445323 31.7667799,11.8965177 C32.2423145,10.7485032 33.3625737,9.99998594 34.6051801,10 C36.299926,10.0048119 37.672588,11.3774894 37.6773807,13.0722354 Z",
      id: "Shape",
      fill: "#FFFFFF",
      fillRule: "nonzero"
    }))));
  };

  var _default = SvgVipps;
  _exports["default"] = _default;
});